import React, {useState} from "react"
import writers from '../../content-static/writers.json'
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import SliderPager from "../SliderPager";
import Academic from "../../components/ImagesComponents/Academic.jsx"
import ShieldDollar from "../../components/ImagesComponents/ShieldDollar.jsx"

import { BaseUrlLink} from "../../helpers/baseUrl";
import StarRatings from 'react-star-ratings';

const Writers = (props) => {
    const [slide, setSlide] = useState()
    const [counter, setCounter] = useState(0)
    const responsive = {
        0: { items: 1 },
        568: {items: props.writersSliderSetting.responsiveViewMobile },
        600: { items: props.writersSliderSetting.responsiveViewTablet2 },
        880: {items: props.writersSliderSetting.responsiveViewTablet},
        1100: { items: props.writersSliderSetting.responsiveViewDesc }
    }
    const items = writers.map((writer, index) => {
        return (
            <div
                aria-hidden
                className={`writer-info-slider__card ${props.writersSliderSetting.deskTop ? '' : 'writer-info-slider__card--single-card' }`}
                key={index}
                onClick={() => slide.slideTo(index)
            }
            >
                <div className="writer-info-slider__card-avatar">
                    <img
                        data-src={writer.avatar_url}
                        className="lazyload"
                        width="80"
                        height="80"
                        alt="writer avatar" />
                </div>
                <div className="writer-info-slider__card-writer">
                    <i>{writer.name}</i>
                    <span>ID: {writer.id}</span>
                </div>
                <div className="writer-info-slider__card-rating">
                    <StarRatings
                        rating={Number(writer.statistics.rank_all)/2}
                        starRatedColor="#FF690C"
                        starDimension="20px"
                        starSpacing="1px"
                        numberOfStars={5}
                        name='rating'
                    />
                    <span className="writer-info-slider__card-rating-rank-all">{(Number(writer.statistics.rank_all)/2).toFixed(1)}</span>
                    <span className="writer-info-slider__card-rating-reviews">({writer.statistics.rank_all_count} reviews)</span>
                </div>
                <div className="writer-info-slider__card-personal">
                    <Academic />
                    <span>"{writer.application.major?.value ? writer.application.major?.value : 'Bachelor, Journalism and Mass Communication' }"</span>
                </div>
                <div className="writer-info-slider__card-footer">
                    <a href={`${BaseUrlLink}/register`} className="button button-secondary">Hire writer</a>
                    {/* <a href={`${BaseUrlLink}/writers/profile/${writer.id}/reviews`} className="button button-border__main">view profile</a> */}
                </div>
            </div>
        )
    })

    return (
        <div className={`${props.writersSliderSetting.deskTop ? 'writer-info' : 'writer-info--single-card'}`}>
            {props.children}
            {/* {props.writersSliderSetting.deskTop &&
                <div className="writer-title title">
                    Meet them now
                </div>
            } */}
            <div className="writer-info-slider">
                <div className="writer-info-slider__wrapper wrapper">
                    <AliceCarousel
                        touchTracking
                        items={items}
                        onSlideChanged={(e) => setCounter(e.item)}
                        activeIndex={counter}
                        responsive={responsive}
                        ref={(el) => setSlide(el)}
                        infinite controlsStrategy="alternate"
                        animationDuration={props.writersSliderSetting.animationDuration}
                        autoPlayInterval={props.writersSliderSetting.autoPlayInterval}
                        animationType={props.writersSliderSetting.animationType}
                        autoPlay={props.writersSliderSetting.autoPlay}
                        showSliderPager={props.writersSliderSetting.showSliderPager}
                        disableButtonsControls={!props.writersSliderSetting.deskTop}
                        disableDotsControls={!props.writersSliderSetting.deskTop}
                    />
                </div>
            </div>
            {props.writersSliderSetting.deskTop && <SliderPager count={counter + 1} all={items.length} />}
            {props.writersSliderSetting.deskTop &&
                <div className='writer-info-btn'>
                    <a
                        href="https://shop.customessaymeister.com/register"
                        className="button button-primary">
                        place an order
                    </a>
                    {/* <a
                        href="https://shop.customessaymeister.com/writers"
                        className="button button-border__main">
                        view all writers
                    </a> */}
                </div>
            }
            {props.writersSliderSetting.deskTop &&
                <div className='writer-info-money-back-guarantee'>
                    <ShieldDollar />
                    <span>Money Back Guarantee</span>
                </div>
            }
        </div>
    )
}

export default Writers